import { render, staticRenderFns } from "./CreateBatchProductionModal.vue?vue&type=template&id=5bf64e48&scoped=true"
import script from "./CreateBatchProductionModal.vue?vue&type=script&lang=js"
export * from "./CreateBatchProductionModal.vue?vue&type=script&lang=js"
import style0 from "./CreateBatchProductionModal.vue?vue&type=style&index=0&id=5bf64e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf64e48",
  null
  
)

export default component.exports